import { z } from 'zod/v4';

export const VMAlertDTO = z.object({
  id: z.string(),
  label: z.string(),
  name: z.string(),
  config: z.string(),
  tags: z.array(z.string()),
  managed_by: z.enum(['SYSTEM', 'USER']),
  deduplication_group_by_labels: z.array(z.string()),
  deduplication_ignore_labels: z.array(z.string()),
  url: z.string().nullish(),
  alert_url: z.string().nullish(),
  api_base_url: z.string().nullish(),
});
export type VMAlert = z.infer<typeof VMAlertDTO>;

export const VMAlertItemDTO = VMAlertDTO.pick({
  id: true,
  name: true,
  label: true,
  tags: true,
});
export type VMAlertItem = z.infer<typeof VMAlertItemDTO>;

export const VMAlertCreateDTO = VMAlertDTO.omit({
  id: true,
}).extend({
  deduplication_group_by_labels: z.array(z.string()).optional(),
  deduplication_ignore_labels: z.array(z.string()).optional(),
});
export type VMAlertTypeCreateRequest = z.infer<typeof VMAlertCreateDTO>;

export const VMAlertUpdateRequestDTO = VMAlertDTO.omit({
  id: true,
  name: true,
  url: true,
  alert_url: true,
}).extend({
  deduplication_group_by_labels: z.array(z.string()).optional(),
  deduplication_ignore_labels: z.array(z.string()).optional(),
});
export type VMAlertTypeUpdateRequest = z.infer<typeof VMAlertUpdateRequestDTO>;